import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    printConfig: [],
};

const printConfigSlice = createSlice({
    name: "printConfig",
    initialState,
    reducers: {
        setPrintConfig: (state, action) => {
            state.printConfig = action.payload;
        },
    }
});

// 🟢 Exporting Actions
export const { setPrintConfig } = printConfigSlice.actions;

// 🔵 Selectors (Getters)
export const selectPrintConfig = (state) => state.printConfig.printConfig;

export const getTransactionByName = (state, type, name) => {
        transactions = selectPrintConfig(state);
   
    return transactions || null;
};

// 🟣 Reducer Export
export default printConfigSlice.reducer;
